module.exports = __webpack_public_path__ + "static/media/macro.acaf4cc4.png";